<div class="listings">
  <h1 class="page_title">Your Listings<span>.</span>
    <p-progressSpinner class="spinner" *ngIf="isLoadingData" styleClass="w-2rem h-2rem" strokeWidth="2"
      fill="var(--surface-ground)" animationDuration="spinnerAnimationDuration">
    </p-progressSpinner>
  </h1>
  <div class="table-container">
    <div class="filters" style="margin-bottom: 1rem;">
      <h2>Filters</h2>
      <div class="filter-row" style="display: flex; flex-wrap: wrap; gap: 1rem;">
        <div class="filter-item">
          <label>Store Code</label>
          <input type="text" pInputText [(ngModel)]="filters.store_code" />
        </div>

        <div class="filter-item">
          <label>Business Name</label>
          <input type="text" pInputText [(ngModel)]="filters.business_name" />
        </div>

        <div class="filter-item">
          <label>Address</label>
          <input type="text" pInputText [(ngModel)]="filters.address" />
        </div>

        <div class="filter-item">
          <label>City</label>
          <input type="text" pInputText [(ngModel)]="filters.city" />
        </div>

        <div class="filter-item">
          <label>State</label>
          <input type="text" pInputText [(ngModel)]="filters.state" />
        </div>

        <div class="filter-item">
          <label>Postal Code</label>
          <input type="text" pInputText [(ngModel)]="filters.postal_code" />
        </div>

        <div class="filter-item">
          <label>Publisher</label>
          <p-dropdown
            [options]="publisherOptions"
            [(ngModel)]="filters.publisher"
            style="width: 200px;"
          ></p-dropdown>
        </div>

        <div class="filter-item">
          <label>Match Status</label>
          <p-dropdown
            [options]="matchStatusOptions"
            [(ngModel)]="filters.match_status"
            style="width: 200px;"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="generate-matches">
      <h2>Generate Matches</h2>
      <div class="generate-matches-container" style="display: flex; flex-wrap: wrap; gap: 1rem;">
        <p-dropdown
          [options]="generateMatchesPublisherOptions"
          [(ngModel)]="generateMatchesPublisher"
          placeholder="Publisher"
          style="width: 200px;"
        ></p-dropdown>
        <button
          pButton
          label="Generate Matches for All"
          (click)="generateMatchesForAllListings()"
          [disabled]="isLoadingData"
        ></button>
        <button
          pButton
          label="Refresh Listings"
          (click)="refreshListings()"
          [disabled]="isLoadingData"
        ></button>
      </div>
    </div>
    <p-table
      id="listingsTable"
      [value]="filteredListings"
      [scrollable]="true"
      [resizableColumns]="true"
      [style.maxWidth]="tableWidth"
      [scrollHeight]="tableHeight"
      selectionMode="single"
      sortMode="multiple"
      [(selection)]="selListing"
      (onRowSelect)="onRowSelect($event)"
      dataKey="listing_id"
    >
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col class="store-code" />
          <col class="business-name" />
          <col class="address" />
          <col class="city" />
          <col class="state" />
          <col class="postal-code" />
          <col class="match-status" />
          <col class="publisher" />
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn pSortableColumn="store_code">Store Code <p-sortIcon field="store_code"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="business_name">Business Name <p-sortIcon field="business_name"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="address">Address <p-sortIcon field="address"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="city">City <p-sortIcon field="city"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="state">State <p-sortIcon field="state"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="postal_code">Postal Code <p-sortIcon field="postal_code"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="match_status">Match Status <p-sortIcon field="match_status"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="publisher">Publisher <p-sortIcon field="publisher"></p-sortIcon></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-listing>
        <tr [pSelectableRow]="listing">
          <td>{{ listing.store_code }}</td>
          <td>{{ listing.business_name }}</td>
          <td>{{ normalizeAddress(listing.address) }}</td>
          <td>{{ listing.city }}</td>
          <td>{{ listing.state }}</td>
          <td>{{ listing.postal_code }}</td>
          <td>{{ listing.match_status }}</td>
          <td>{{ listing.publisher }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
